import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const Footer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
  flexFlow: 'wrap',
  justifyContent: 'space-between'
}));

export const PartnerImage = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),

  '& img': {
    height: '1rem',
    width: 'auto'
  }
}));
